import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoMenu from "./../../services/bao-menu";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import BaseViewModel from "./../../factories/base-view-model";
import TreeNodeViewModel from "./../../factories/tree-node";
import TranslateDialogViewModel from "./../../factories/translate-dialog";
import "./../../bindings/bao-tree";
function FolderViewModel(tabPage) {
    var self = this;
    self.FolderName = ko.observable();
    self.FolderName1 = ko.observable();
    self.FolderName2 = ko.observable();
    self.FolderName3 = ko.observable();
    self.FolderName4 = ko.observable();
    self.FolderName5 = ko.observable();
    self.Translate = function () {
        var translateDialog = new TranslateDialogViewModel(self.FolderName1, self.FolderName2, self.FolderName3, self.FolderName4, self.FolderName5);
        tabPage.IsLoading(true);
        translateDialog.Open().then(function () {
            tabPage.IsLoading(false);
        });
    };
    self.FolderNameComputed = ko.computed(function () {
        self.FolderName1();
        self.FolderName2();
        self.FolderName3();
        self.FolderName4();
        self.FolderName5();
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.FolderName(self.FolderName1());
                break;
            case 2:
                self.FolderName(self.FolderName2());
                break;
            case 3:
                self.FolderName(self.FolderName3());
                break;
            case 4:
                self.FolderName(self.FolderName4());
                break;
            case 5:
                self.FolderName(self.FolderName5());
                break;
        }
    });
    self.FolderName.subscribe(function () {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.FolderName1(self.FolderName());
                break;
            case 2:
                self.FolderName2(self.FolderName());
                break;
            case 3:
                self.FolderName3(self.FolderName());
                break;
            case 4:
                self.FolderName4(self.FolderName());
                break;
            case 5:
                self.FolderName5(self.FolderName());
                break;
        }
    });
}
function FolderStructureViewModel(tabPage) {
    var self = this;
    self.Bao = Bao;
    BaseViewModel.call(this, tabPage);
    self.Nodes = ko.observableArray([]);
    self.SelectedNode = ko.observable();
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        if (self.SelectedNode() != null) {
            self.GetFolderStructureChecklists(self.SelectedNode().Key());
        }
        else {
            self.GetFolderStructureChecklists(null);
        }
    });
    self.PageSize = ko.observable(50);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        if (self.SelectedNode() != null) {
            self.GetFolderStructureChecklists(self.SelectedNode().Key());
        }
        else {
            self.GetFolderStructureChecklists(null);
        }
    });
    self.FolderStructureChecklistCollection = ko.observableArray([]);
    self.SelectFolderStructureChecklistRow = function (item) {
        self.SelectedFolderStructureChecklistRow(item);
        return true;
    };
    self.SelectedFolderStructureChecklistRow = ko.observable();
    self.SelectedFolderStructureChecklistRow.subscribe(function () {
        self.ToggleButtons();
    });
    self.SelectedNode.subscribe(function () {
        self.ToggleButtons();
        if (self.PageIndex() != 0) {
            self.PageIndex(0);
        }
        else {
            if (self.SelectedNode() != null) {
                self.GetFolderStructureChecklists(self.SelectedNode().Key());
            }
            else {
                self.GetFolderStructureChecklists(null);
            }
        }
    });
    self.ToggleButtons = function () {
        var enabled = self.SelectedNode() != null;
        BaoMenu.permissionEnable({
            ActionKey: "FolderStructureAdd",
            Enabled: enabled && self.SelectedNode().Level() < 4,
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "FolderStructureEdit",
            Enabled: enabled,
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "FolderStructureDelete",
            Enabled: enabled,
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "FolderStructureChecklistAdd",
            Enabled: enabled,
            Context: tabPage.Context()
        });
        var enabledChecklistButtons = self.SelectedFolderStructureChecklistRow() != null;
        BaoMenu.permissionEnable({
            ActionKey: "FolderStructureChecklistRemove",
            Enabled: enabledChecklistButtons,
            Context: tabPage.Context()
        });
        // move up/down
        let nodeCollection: any[] = null;
        if (self.SelectedNode()?.Parent != null) {
            nodeCollection = self.SelectedNode()?.Parent?.Nodes();
        }
        else {
            nodeCollection = self.Nodes();
        }
        const count = ko.unwrap(nodeCollection)?.length ?? 0;
        BaoMenu.permissionEnable({
            ActionKey: "FolderStructureMoveUp",
            Enabled: enabled && count >= 2 && nodeCollection && nodeCollection[0] !== self.SelectedNode(),
            Context: tabPage.Context()
        });

        BaoMenu.permissionEnable({
            ActionKey: "FolderStructureMoveDown",
            Enabled: enabled && count >= 2 && nodeCollection && nodeCollection[count-1] !== self.SelectedNode(),
            Context: tabPage.Context()
        });
    };
    self.Delete = function () {
        var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteFolderStructure"), "yesno");
        yesNoDialog.DialogResult.subscribe(function (result) {
            if (result === true) {
                tabPage.IsLoading(true);
                Bao.post("Checkware/FolderStructure/Delete", JSON.stringify({
                    folderStructureId: self.SelectedNode().Key()
                }), function () {
                    var newNodes = [];
                    var nodeCollection;
                    if (self.SelectedNode().Parent != null) {
                        nodeCollection = self.SelectedNode().Parent.Nodes;
                    }
                    else {
                        nodeCollection = self.Nodes;
                    }
                    $.each(nodeCollection(), function (index, item) {
                        if (item != self.SelectedNode()) {
                            newNodes.push(item);
                        }
                    });
                    nodeCollection(newNodes);
                    self.SelectedNode(null);
                    tabPage.IsLoading(false);
                });
            }
        });
    };
    self.AddRoot = function () {
        return Bao.post("Checkware/FolderStructure/NewModel", function (newModel) {
            self.ShowDialog(newModel, function (result) {
                return self.SaveNew(result, null);
            });
        });
    };
    self.Add = function () {
        return Bao.post("Checkware/FolderStructure/NewModel", function (newModel) {
            self.ShowDialog(newModel, function (result) {
                return self.SaveNew(result, self.SelectedNode().Key());
            });
        });
    };
    self.Save = function (folderStructure) {
        tabPage.IsLoading(true);
        self.SelectedNode().Text(folderStructure.FolderName());
        return Bao.post("Checkware/FolderStructure/Save", JSON.stringify({
            folder: ko.map.toJS(folderStructure)
        }), function () {
            if (self.SelectedNode().Parent != null) {
                self.SortNodes(self.SelectedNode().Parent.Nodes);
            }
            else {
                self.SortNodes(self.Nodes());
            }
            tabPage.IsLoading(false);
        });
    };
    self.SaveNew = function (folder, parentFolderStructureId) {
        tabPage.IsLoading(true);
        return Bao.post("Checkware/FolderStructure/SaveNew", JSON.stringify({
            folder: ko.map.toJS(folder),
            parentFolderStructureId: parentFolderStructureId
        }), function (node) {
            var newNode;
            if (parentFolderStructureId == null) {
                newNode = new TreeNodeViewModel(node);
                self.Nodes.push(newNode);
                self.SortNodes(self.Nodes);
                self.SelectedNode(newNode);
            }
            else {
                newNode = new TreeNodeViewModel(node, self.SelectedNode());
                self.SelectedNode().Nodes.push(newNode);
                self.SortNodes(self.SelectedNode().Nodes);
                self.SelectedNode(newNode);
            }
            tabPage.IsLoading(false);
        });
    };
    self.SortNodes = function (nodesArray) {
        nodesArray.sort(function (itemA, itemB) {
            const sortA = itemA.Sort();
            const sortB = itemB.Sort();

            if (sortA === sortB) {
                const textA = itemA.Text().toLowerCase();
                const textB = itemB.Text().toLowerCase();
                return textA === textB ? 0 : textA < textB ? -1 : 1;
            }
            else {
                sortA < sortB ? -1 : 1;
            }         
        });
    };
    self.ShowDialog = function (dialogDataSource, fn) {
        tabPage.IsLoading(true);
        Bao.get("Checkware/FolderStructure/Dialog", function (dialogView) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: function () {
                        fn(dialog.ViewModel()).then(dialog.Close);
                    },
                    Enabled: ko.observable(true)
                }, {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: function () {
                        dialog.Close();
                    },
                    Enabled: ko.observable(true)
                }]);
            var dialogVM = new FolderViewModel(tabPage);
            ko.map.fromJS(dialogDataSource, dialogVM);
            dialog.ViewModel(dialogVM);
            dialog.Template(dialogView);
            dialog.Open();
            tabPage.IsLoading(false);
        });
    };
    self.Edit = function () {
        tabPage.IsLoading(true);
        return Bao.post("Checkware/FolderStructure/Edit", JSON.stringify({
            folderStructureId: self.SelectedNode().Key()
        }), function (editResult) {
            self.ShowDialog(editResult, function (editVM) {
                return self.Save(editVM);
            });
        });
    };
    self.Refresh = function () {
        tabPage.IsLoading(true);
        self.SelectedNode(null);
        return Bao.post("Checkware/FolderStructure/Load", function (value) {
            var newItems = [];
            if (value != null && value.length > 0) {
                $.each(value, function (index, row) {
                    var node = new TreeNodeViewModel(row);
                    newItems[index] = node;
                });
            }
            self.Nodes(newItems);
            tabPage.IsLoading(false);
        });
    };
    self.GetFolderStructureChecklists = function (folderStructureId) {
        tabPage.IsLoading(true);
        if (folderStructureId != null) {
            return Bao.post("Checkware/FolderStructure/GetFolderStructureChecklists", JSON.stringify({
                folderStructureId: folderStructureId,
                pageIndex: self.PageIndex(),
                pageSize: self.PageSize(),
                sorting: self.Sorting()
            }), function (searchResult) {
                self.SelectedFolderStructureChecklistRow(null);
                self.TotalRows(0);
                self.FolderStructureChecklistCollection([]);
                if (searchResult != null && searchResult.Models != null) {
                    self.FolderStructureChecklistCollection(searchResult.Models);
                    self.TotalRows(searchResult.TotalRows);
                }
                tabPage.IsLoading(false);
            });
        }
        else {
            self.SelectedFolderStructureChecklistRow(null);
            self.TotalRows(0);
            self.FolderStructureChecklistCollection([]);
            tabPage.IsLoading(false);
        }
    };
    self.AddChecklistToFolderStructure = function (folderStructureId, checklistId) {
        tabPage.IsLoading(true);
        return Bao.post("Checkware/FolderStructure/AddFolderStructureChecklist", JSON.stringify({
            folderStructureId: folderStructureId,
            checklistId: checklistId
        }), function (result) {
            if (result.Result == true) {
                self.GetFolderStructureChecklists(folderStructureId);
                Bao.raiseEvent("checkware:refresh_folderstructurechecklist");
            }
            tabPage.IsLoading(false);
        });
    };
    self.AddChecklist = function () {
        tabPage.IsLoading(true);
        var folderStructureId = self.SelectedNode().Key();
        window.baorequire(["Factories/baoSearchDialog"], function (baoSearchDialog) {
            var searchDialogConfig = {
                ApplyItemCallback: function (searchVm) {
                    var checklistId = searchVm.SelectedItem().ChecklistId;
                    self.AddChecklistToFolderStructure(folderStructureId, checklistId);
                },
                MultiSelect: false,
                SearchType: "Checkware-Checklist",
                ObjectId: ko.observable(),
                ObjectValue: "ChecklistId"
            };
            var searchDialog = new baoSearchDialog();
            searchDialog.InitSearcher(searchDialogConfig);
            tabPage.IsLoading(false);
        });
    };
    self.RemoveChecklist = function () {
        Bao.post("Checkware/FolderStructure/GetRemoveFolderStructureMessage", JSON.stringify({
            checklistName: self.SelectedFolderStructureChecklistRow().ListName,
            folderStructureName: self.SelectedNode().Text()
        }), function (deleteFolderStructureChecklistMessage) {
            if (!(self.SelectedFolderStructureChecklistRow() == null)) {
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, deleteFolderStructureChecklistMessage, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.TabPage.IsLoading(true);
                        return Bao.post("Checkware/FolderStructure/RemoveFolderStructureChecklist", JSON.stringify({
                            folderStructureChecklistId: self.SelectedFolderStructureChecklistRow().FolderStructureChecklistId
                        })).then(function () {
                            self.GetFolderStructureChecklists(self.SelectedNode().Key());
                        });
                    }
                });
            }
        });
    };

    /*
     * Function for changing the order of the selected item
     * */
    self.MoveFolderStructure = function (moveUp: boolean) {
        if (self.SelectedNode()?.Key()) {
            Bao.post("Checkware/FolderStructure/MoveFolderStructure", JSON.stringify({
                folderStructureId: self.SelectedNode().Key(),
                moveUp: moveUp
            })).then(res => {
                if (res.Result) {
                    return self.Refresh();
                }
            });
        }
    };

    BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab()) {
            switch (value.ActionKey()) {
                case "FolderStructureAdd":
                    self.Add();
                    break;
                case "FolderStructureEdit":
                    self.Edit();
                    break;
                case "FolderStructureDelete":
                    self.Delete();
                    break;
                case "FolderStructureAddRoot":
                    self.AddRoot();
                    break;
                case "FolderStructureRefresh":
                    self.Refresh();
                    break;
                case "FolderStructureChecklistAdd":
                    self.AddChecklist();
                    break;
                case "FolderStructureChecklistRemove":
                    self.RemoveChecklist();
                    break;
                case "FolderStructureMoveUp":
                    self.MoveFolderStructure(true);
                    break;
                case "FolderStructureMoveDown":
                    self.MoveFolderStructure(false);
                    break;
            }
        }
    });
    self.loaded = function () {
        tabPage.DirtyFlag.reset();
        self.ToggleButtons();
        return self.Refresh();
    };
}
Bao.inherit(FolderStructureViewModel, BaseViewModel);
export default FolderStructureViewModel;